import React, { Component } from 'react';

// Externals
import PropTypes from 'prop-types';

// Material helpers
import { withStyles } from '@material-ui/core/styles';

// Material components
import Grid from '@material-ui/core/Grid';

// Shared layouts
import DashboardLayout from 'layouts/Dashboard';

//Componentes Atentus
import QuickViewIspFull from '../../../Dashboard/components/QuickViewIspFull'


// Component styles
const styles = theme => ({
    root: {
        padding: theme.spacing(3),
        backgroundColor: '#525252',
        height: '100%',
        width: '100%',
    },
    item: {
        height: '100%',
        width: '100%',
    }
});

class QuickViewFullView extends Component {
    constructor(props) {
        super(props);
        this.myCallback = this.myCallback.bind(this);
        this.state = {
            objectivesList: {}
        } 
    }
    myCallback = (dataFromChild) => {
        this.setState({
            objectivesList: dataFromChild
        })


    }
    render() {
        const { classes } = this.props;
        const { objectivesList, filterList } = this.state
        return (
            <div>
                <QuickViewIspFull params={objectivesList} />
            {/*}    <UserNotification  />
            <DashboardLayout title="Vista Rápida por Isp" callbackFromParent={this.myCallback} isFirstTime={true}>
                <div className={classes.root}>
                    <Grid
                        container
                        spacing={10}
                    >

                        <Grid
                            item
                            sm={12}
                            xl={12}
                            xs={12}
                        >
                            <QuickViewIsp params={objectivesList} />
                        </Grid>
                    </Grid>
                </div>
        </DashboardLayout>*/}
            </div>
        );
    }
}

QuickViewFullView.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(QuickViewFullView);
